export function getFallbackStateFinance({ isLoading, allData, filteredData }) {
  if (isLoading) return { state: "loading" };
  if (!allData || allData.length === 0) return { state: "noData" };
  if (filteredData.length === 0) return { state: "noMatch" };
  return { state: "ok" };
}
